import * as React from 'react';

import {Text} from './Text';

interface ITag {
  color: string;
  title: string;
}

export const Tag = ({color, title}: ITag) => {
  return (
    <Text
      as="div"
      variant="Caption"
      className="rounded-full px-3 py-1 w-fit h-8 flex items-center"
      style={{backgroundColor: color}}>
      {title}
    </Text>
  );
};
